import React, { useState } from 'react';
import { ui } from './toolTheme';

const API_BASE = process.env.REACT_APP_API_BASE || '';
const downloadBlob = (blob, name) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = name;
  document.body.appendChild(a); a.click(); document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

const PdfToolkitPage = ({ setPage }) => {
  const [files, setFiles] = useState([]);
  const [single, setSingle] = useState(null);
  const [ranges, setRanges] = useState('1-2,3');
  const [angle, setAngle] = useState(90);
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState('');

  const run = async (path, fd, outName) => {
    setErr(''); setBusy(path);
    try {
      const res = await fetch(`${API_BASE}${path}`, { method: 'POST', body: fd });
      if (!res.ok) throw new Error((await res.json().catch(() => ({}))).message || `Failed (${res.status})`);
      const blob = await res.blob();
      downloadBlob(blob, outName);
    } catch (e) { setErr(e.message || 'Failed'); }
    finally { setBusy(''); }
  };

  return (
    <main style={ui.page}>
      <div style={ui.container}>
        <button onClick={() => setPage('/tools')} style={ui.backBtn}>← Back to Tools</button>
        <div style={ui.card}><h1 style={ui.sectionTitle}>PDF Merge / Split / Compress / Rotate</h1></div>

        <div style={{ ...ui.card, marginTop: 14 }}>
          <h3 style={{ color: '#cbd5e1' }}>Merge PDFs</h3>
          <input type="file" accept="application/pdf" multiple onChange={(e) => setFiles(Array.from(e.target.files || []))} style={ui.fileInput} />
          <button disabled={busy === '/api/pdf/merge'} onClick={() => {
            const fd = new FormData(); files.forEach((f) => fd.append('files', f));
            run('/api/pdf/merge', fd, 'merged.pdf');
          }} style={{ ...ui.primaryBtn, marginTop: 10 }}>Merge</button>
        </div>

        <div style={{ ...ui.card, marginTop: 14 }}>
          <h3 style={{ color: '#cbd5e1' }}>Split PDF</h3>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 160px auto', gap: 8 }}>
          <input type="file" accept="application/pdf" onChange={(e) => setSingle(e.target.files?.[0] || null)} style={ui.fileInput} />
          <input value={ranges} onChange={(e) => setRanges(e.target.value)} placeholder="1-2,4" style={ui.input} />
          <button disabled={busy === '/api/pdf/split' || !single} onClick={() => {
            const fd = new FormData(); fd.append('file', single); fd.append('ranges', ranges);
            run('/api/pdf/split', fd, 'pdf_splits.zip');
          }} style={ui.primaryBtn}>Split</button>
          </div>
        </div>

        <div style={{ ...ui.card, marginTop: 14 }}>
          <h3 style={{ color: '#cbd5e1' }}>Rotate PDF</h3>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 120px auto', gap: 8 }}>
          <input type="file" accept="application/pdf" onChange={(e) => setSingle(e.target.files?.[0] || null)} style={ui.fileInput} />
          <select value={angle} onChange={(e) => setAngle(Number(e.target.value))} style={ui.select}>
            <option value={90}>90°</option><option value={180}>180°</option><option value={270}>270°</option>
          </select>
          <button disabled={busy === '/api/pdf/rotate' || !single} onClick={() => {
            const fd = new FormData(); fd.append('file', single); fd.append('angle', String(angle));
            run('/api/pdf/rotate', fd, 'rotated.pdf');
          }} style={ui.primaryBtn}>Rotate</button>
          </div>
        </div>

        <div style={{ ...ui.card, marginTop: 14 }}>
          <h3 style={{ color: '#cbd5e1' }}>Compress PDF</h3>
          <input type="file" accept="application/pdf" onChange={(e) => setSingle(e.target.files?.[0] || null)} style={ui.fileInput} />
          <button disabled={busy === '/api/pdf/compress' || !single} onClick={() => {
            const fd = new FormData(); fd.append('file', single);
            run('/api/pdf/compress', fd, 'compressed.pdf');
          }} style={{ ...ui.primaryBtn, marginTop: 10 }}>Compress</button>
        </div>
        {err && <div style={ui.error}>{err}</div>}
      </div>
    </main>
  );
};

export default PdfToolkitPage;
